import { html, unsafeCSS, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./card.css?inline";

@customElement("eko-card")
export class Card extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) admin: boolean = false;
  @property({ type: Boolean }) block: boolean = false;
  @property({ reflect: true }) href?: string;
  @property({ reflect: true }) padding: "none" | "xl" | "lg" | "md" | "sm" = "lg";
  @property({ reflect: true, type: Boolean }) reverse: boolean = false;

  render() {
    return this.href ? this.renderLink() : this.renderCard();
  }

  renderCard() {
    return html`${this.admin
        ? html`<eko-admin-background-pattern></eko-admin-background-pattern>`
        : nothing}
      <slot name="header"></slot>
      <div class="eko-card__content" part="content">
        <slot></slot>
        ${this.block
          ? html`<div class="eko-card__block" part="block">
              <slot name="icon"></slot>
              <div class="eko-card__block-content" part="block-content">
                <span class="eko-card__block-title" part="block-title">
                  <slot name="title"></slot>
                  ${this.admin
                    ? html`<span class="eko-card__block-admin"
                        ><eko-admin-icon tooltip></eko-admin-icon
                      ></span>`
                    : nothing}
                </span>
                <slot name="description"></slot>
              </div>
            </div>`
          : nothing}
      </div>
      <slot name="footer"></slot>`;
  }

  renderLink() {
    return html`<a href=${this.href as string} part="link">${this.renderCard()}</a>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card": Card;
  }
}

export default Card;
